import Vue from 'vue'
import Vuex from 'vuex'
import { getUnbindall, getBind } from '../../../fetch/bind-account'
Vue.use(Vuex)
export const types = {
/**
 * 已绑定
 */
  GET_BUNBINDALL: 'GET_BUNBINDALL',

  /**
   * 绑定
   */

  GET_BIND: 'GET_BIND'
}
export default {
  state: {
    [types.GET_BUNBINDALL]: null,
    [types.GET_BIND]: null
  },
  mutations: {
    [types.GET_BUNBINDALL]: (state, res) => {
      state[types.GET_BUNBINDALL] = res
    },
    [types.GET_BUNBINDALL]: (state, res) => {
      state[types.GET_BIND] = res
    }
  },
  actions: {
    [types.GET_BUNBINDALL]: async ({ commit }, params) => {
      const res = await getUnbindall(params)
      return commit(types.GET_BUNBINDALL, res)
    },
    [types.GET_BIND]: async ({ commit }, params) => {
      const res = await getBind(params)
      return commit(types.GET_BIND, res)
    }
  },
  getters: {
    getUnbindall (state) {
      return state[types.GET_BUNBINDALL]
    },
    getBind (state) {
      return state[types.GET_BIND]
    }
  }
}
